import { FILTER_LABEL } from "../components/quote-filter/config/wording";
import { IAirTripQuoteCurrency } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

export const FILTER_CONFIG: IFilterConfig = {
    beginPlusOrMinus: {
        filterLabel: FILTER_LABEL.beginPlusOrMinus,
        type: 'checkbox',
        isBySegment: false,
        show: false,
    },
    cost: {
        filterLabel: FILTER_LABEL.cost,
        type: 'slider',
        format: 'price',
        show: false,
    },
    retail: {
        filterLabel: FILTER_LABEL.retail,
        type: 'slider',
        format: 'price',
        show: false,
    },
    fareType: {
        filterLabel: FILTER_LABEL.fareType,
        type: 'checkbox',
        isBySegment: false,
        show: false,
    },
    from: {
        filterLabel: FILTER_LABEL.from,
        type: 'checkbox',
        isBySegment: true,
        show: false,
    },
    to: {
        filterLabel: FILTER_LABEL.to,
        type: 'checkbox',
        isBySegment: true,
        show: false,
    },
    begin: {
        filterLabel: FILTER_LABEL.begin,
        isBySegment: true,
        format: 'time',
        type: 'slider',
        show: false,
    },
    end: {
        filterLabel: FILTER_LABEL.end,
        isBySegment: true,
        format: 'time',
        type: 'slider',
        show: false,
    },
    duration: {
        filterLabel: FILTER_LABEL.duration,
        isBySegment: true,
        format: 'duration',
        type: 'slider',
        show: false,
    },
    durationStop: {
        filterLabel: FILTER_LABEL.durationStop,
        isBySegment: true,
        format: 'duration',
        type: 'slider',
        show: false,
    },
    stop: {
        filterLabel: FILTER_LABEL.stop,
        type: 'checkbox',
        isBySegment: true,
        show: false,
    },
    carrier: {
        filterLabel: FILTER_LABEL.carrier,
        type: 'checkbox',
        isBySegment: true,
        show: false,
    },
    via: {
        filterLabel: FILTER_LABEL.via,
        type: 'checkbox',
        isBySegment: true,
        show: false,
    },
    host: {
        filterLabel: FILTER_LABEL.host,
        type: 'checkbox',
        show: false,
    },
    carbonFootprint: {
        filterLabel: FILTER_LABEL.carbonFootprint,
        type: 'slider',
        show: false,
        format: "carbonFootprint",
    },
    rating: {
        filterLabel: FILTER_LABEL.rating,
        type: 'slider',
        show: false,
        format: "rating"
    }
};

export interface IFilterConfig {
    [key: string]: IFilterConfigField;
}

export interface IFilterConfigField {
    type: 'checkbox' | 'slider';
    isBySegment?: boolean;
    format?: 'duration' | 'time' | 'price' | 'carbonFootprint' | 'rating';
    show: boolean;
    filterLabel: string;
    currency?: IAirTripQuoteCurrency;
}
